import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname"];
import { Button } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Submit = props => {
  var {
      keyname = 'submit'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (!elmProps.children) {
    elmProps.children = 'Submit';
  }
  return /*#__PURE__*/_jsx(Button, _extends({
    type: "submit",
    keyname: keyname
  }, elmProps));
};
Submit.displayName = 'BaseLogin.Submit';